import type { Question } from '@shared/domain/form/index.js';
import type { CurrentReview } from '@shared/domain/review/index.js';
import { liabilityValueMap } from '../constants/review.constants.js';

export const shouldShowQuestion = (question: Question, formFields: CurrentReview): boolean => {
  if (!formFields || !question.conditionalShowRules) {
    return true;
  }

  return question.conditionalShowRules.every((rule) => {
    const fieldValue = formFields[rule.field as keyof CurrentReview];
    const comparisonValue = rule.compareTo ? formFields[rule.compareTo as keyof CurrentReview] : undefined;

    if (fieldValue === undefined && comparisonValue === undefined) {
      return false;
    }

    if (rule.notValues) {
      if (!fieldValue) {
        return false;
      }
      return !rule.notValues.includes(fieldValue as string);
    }

    if (rule.value !== undefined) {
      return fieldValue === rule.value;
    }

    if (rule.comparison && comparisonValue !== undefined) {
      const fieldNumericValue = liabilityValueMap[fieldValue as string] ?? Number(fieldValue);
      const comparisonNumericValue = liabilityValueMap[comparisonValue as string] ?? Number(comparisonValue);

      if (fieldNumericValue === undefined || comparisonNumericValue === undefined) {
        return false;
      }

      switch (rule.comparison) {
        case 'equalTo': {
          return fieldNumericValue === comparisonNumericValue;
        }
        case 'greaterThan': {
          return fieldNumericValue > comparisonNumericValue;
        }
        case 'lessThan': {
          return fieldNumericValue < comparisonNumericValue;
        }
        default: {
          return false;
        }
      }
    }

    return true;
  });
};

export const getLoaderText = (): string => {
  return 'Loading Review...';
};
